<template>
  <section class="announcement-block">
    <div class="container" :style="data.image ? { backgroundImage: `url(${data.image})` } : {}">
      <div class="row">
        <div class="col-lg-7">
          <h3 class="title">
            {{ data.title }}
          </h3>
          <p class="subtitle">
            {{ data.subtitle }}
          </p>
          <div class="cta">
            <CallToAction
              v-for="(action, idx) in data.cta"
              :key="idx"
              :model="action"
            />
          </div>
        </div>
        <div class="col-lg-5"> 
          <NuxtImg
            v-if="data.image.length > 0"
            provider="kontentAiProvider"
            :src="data.image"
            class="image"
          />         
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { AnnouncementBannerModel, CallToActionModel } from '~/models'
const announcementStore = useAnnouncementStore()
const pageStore = usePageStore()
const props = defineProps<{ model: AnnouncementBannerModel }>()

const announcementCtas = announcementStore.getListAs<CallToActionModel>(
  props.model?.elements?.callToAction?.value
)

const ctaItem = props.model?.elements?.callToAction?.value?.[0]
const data = {
  title: props.model?.elements?.title?.value ?? '',
  subtitle: props.model?.elements?.subtitle?.value ?? '',
  image: props.model?.elements?.image?.value?.[0]?.url ?? '',
  cta:
    announcementCtas.length > 0
      ? announcementCtas
      : ctaItem ? [pageStore.getLinkedItem<CallToActionModel>(ctaItem)] : []
}
</script>
